export const getResultForYear = (vehicleTypeCode, weeklyKm) =>{
    const vehicleType = vehicleTypes.find(v=>v.code()===vehicleTypeCode) || vehicleTypes[4];

    if(vehicleType){
        const kmDriven = weeklyKm * 52;
        const litresPerYear = kmDriven/100*vehicleType.litresPer100km;
        const kgCo2PerLitre = FUEL_KG_CO2_PER_LITRE[vehicleType.fuel];
        
        return {co2: litresPerYear*kgCo2PerLitre, metadata:{kgCo2PerLitre, litresPer100km: vehicleType.litresPer100km, fuel:vehicleType.fuel ,carSize:vehicleType.size, kmDriven}};
    }
}

export function VehicleType(size, fuel, litresPer100km) {
    this.size = size;
    this.fuel = fuel;
    this.litresPer100km = litresPer100km;
    this.code = ()=> {
        return `${this.size}-${this.fuel}`;
    }
    this.displayName = ()=> {
        return `${codeToLabel.get(this.size)}${codeToLabel.get(this.size) ? ' - ' : ''}${codeToLabel.get(this.fuel)}`;
    }
}

const FUEL_KG_CO2_PER_LITRE= {
    PETROL: 2.31,
    DIESEL: 2.68,
    HYBRID: 0.1725,
    PLUGIN_HYBRID: 0.09,
    ELECTRIC: 0.023
}

const codeToLabel = new Map([
    ['SMALL', 'Small'],
    ['COMPACT', 'Compact'],
    ['MEDIUM', 'Medium'],
    ['LARGE', 'Large'],
    ['UNKNOWN', ''],
    ['PETROL', 'Petrol'],
    ['DIESEL', 'Diesel'],
    ['HYBRID', 'Hybrid'],
    ['PLUGIN_HYBRID', 'Plug-in hybrid'],
    ['ELECTRIC', 'Electric']
]);

//DO NOT EDIT THESE STRINGS - THEY'RE USED BY THE BACKEND (eg reduce-api)
export const vehicleTypes=[
    new VehicleType("SMALL", "PETROL", 6.75),
    new VehicleType("SMALL", "DIESEL", 4.6),
    new VehicleType("COMPACT", "PETROL", 7.69),
    new VehicleType("COMPACT", "DIESEL", 6.12),
    new VehicleType("MEDIUM", "PETROL", 10.23),
    new VehicleType("MEDIUM", "DIESEL", 7.93),
    new VehicleType("LARGE", "PETROL", 11.96),
    new VehicleType("LARGE", "DIESEL", 9.7),
    new VehicleType('UNKNOWN', "HYBRID", 100),
    new VehicleType('UNKNOWN', "PLUGIN_HYBRID", 100),
    new VehicleType('UNKNOWN', "ELECTRIC", 100)
]
//DO NOT EDIT THESE STRINGS - THEY'RE USED BY THE BACKEND
